import React from 'react';
import './styles.scss';
import { connect } from 'react-redux';
import { noop } from '../../common/propTypes';
import PropTypes from 'prop-types';

import {
    fetch15MinRequested,
    fetch1HourRequested,
    fetch6HourRequested,
} from './actions';
import {
    getData15Min,
    getFetching15Min,
    getData15MinError,
    getData15MinInterval,
    getData1Hour,
    getFetching1Hour,
    getData1HourError,
    getData1HourInterval,
    getData6Hour,
    getFetching6Hour,
    getData6HourError,
    getData6HourInterval,
} from './selectors';
import StatsCard from './StatsCard';

function MonitorStats({
    data15Min,
    isLoading15Min,
    error15Min,
    interval15Min,
    on15MinTrigger,
    data1Hour,
    isLoading1Hour,
    error1Hour,
    interval1Hour,
    on1HourTrigger,
    data6Hour,
    isLoading6Hour,
    error6Hour,
    interval6Hour,
    on6HourTrigger,
}) {
    return (
        <div className="monitor-stats">
            <StatsCard
                heading="Previous 15 min"
                data={data15Min}
                isLoading={isLoading15Min}
                error={error15Min}
                interval={interval15Min}
                fetchData={on15MinTrigger}
                difference={15 * 60 * 1000}
            />
            <StatsCard
                heading="Previous 1 hour"
                data={data1Hour}
                isLoading={isLoading1Hour}
                error={error1Hour}
                interval={interval1Hour}
                fetchData={on1HourTrigger}
                difference={60 * 60 * 1000}
            />
            <StatsCard
                heading="Previous 6 hours"
                data={data6Hour}
                isLoading={isLoading6Hour}
                error={error6Hour}
                interval={interval6Hour}
                fetchData={on6HourTrigger}
                difference={360 * 60 * 1000}
            />
        </div>
    );
}

MonitorStats.propTypes = {
    data15Min: PropTypes.object,
    isLoading15Min: PropTypes.bool,
    error15Min: PropTypes.string,
    interval15Min: PropTypes.number.isRequired,
    on15MinTrigger: PropTypes.func,

    data1Hour: PropTypes.object,
    isLoading1Hour: PropTypes.bool,
    error1Hour: PropTypes.string,
    interval1Hour: PropTypes.number.isRequired,
    on1HourTrigger: PropTypes.func,

    data6Hour: PropTypes.object,
    isLoading6Hour: PropTypes.bool,
    error6Hour: PropTypes.string,
    interval6Hour: PropTypes.number.isRequired,
    on6HourTrigger: PropTypes.func,
};

MonitorStats.defaultProps = {
    data15Min: {
        countries: [],
        litters: '',
        users: '',
        progress: [],
        status: [],
    },
    isLoading15Min: false,
    error15Min: '',
    on15MinTrigger: noop,

    data1Hour: {
        countries: [],
        litters: '',
        users: '',
        progress: [],
        status: [],
    },
    isLoading1Hour: false,
    error1Hour: '',
    on1HourTrigger: noop,

    data6Hour: {
        countries: [],
        litters: '',
        users: '',
        progress: [],
        status: [],
    },
    isLoading6Hour: false,
    error6Hour: '',
    on6HourTrigger: noop,
};

const mapStateToProps = (state) => {
    return {
        data15Min: getData15Min(state),
        isLoading15Min: getFetching15Min(state),
        error15Min: getData15MinError(state),
        interval15Min: getData15MinInterval(state),

        data1Hour: getData1Hour(state),
        isLoading1Hour: getFetching1Hour(state),
        error1Hour: getData1HourError(state),
        interval1Hour: getData1HourInterval(state),

        data6Hour: getData6Hour(state),
        isLoading6Hour: getFetching6Hour(state),
        error6Hour: getData6HourError(state),
        interval6Hour: getData6HourInterval(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        on15MinTrigger: (startDate, endDate) => {
            dispatch(fetch15MinRequested({ startDate, endDate }));
        },
        on1HourTrigger: (startDate, endDate) => {
            dispatch(fetch1HourRequested({ startDate, endDate }));
        },
        on6HourTrigger: (startDate, endDate) => {
            dispatch(fetch6HourRequested({ startDate, endDate }));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MonitorStats);
